export class YearListRequest {
    body() {
        return {
            criteria: {
                construction_id: undefined,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/year-list/YearListRequest.js